import * as d3 from 'd3';
import { workHourColorScale, gdpGrowthColorScale } from './colorScale';

let data = null;

const section = d3.select('.survey');
const $figure = section.select('.survey--graphic');
const $svg = $figure.select('svg#survey--marimekko');

let HEIGHT = 0;
let WIDTH = 0;
const MARGIN = { top: 20, bottom: 40, left: 50, right: 110 };
let r = 4;

function updateDimension() {
  WIDTH = 1000 - MARGIN.left - MARGIN.right;
  // WIDTH = 0.8 * window.innerWidth - MARGIN.left - MARGIN.right;
  HEIGHT = 600 - MARGIN.top - MARGIN.bottom;
}

const format = d3.format('.2%');

function treemap(data) {
  return d3
    .treemap()
    .round(true)
    .tile(d3.treemapSliceDice)
    .size([WIDTH, HEIGHT])(data)
    .each(d => {
      d.x0 += MARGIN.left;
      d.x1 += MARGIN.left;
      d.y0 += MARGIN.top;
      d.y1 += MARGIN.top;
    });
}

function resize() {
  updateDimension();

  $svg
    .attr('width', WIDTH + MARGIN.left + MARGIN.right)
    .attr('height', HEIGHT + MARGIN.top + MARGIN.bottom);

  const root = treemap(data);
  window.root = root;

  const node = $svg
    .selectAll('g')
    .data(root.descendants())
    .join('g')
    .attr('transform', d => `translate(${d.x0}, ${d.y0})`);

  const column = node.filter(d => d.depth === 1);
  column.selectAll('*').remove();

  column
    .append('text')
    .attr('x', d => (d.x1 - d.x0) / 2)
    .attr('y', d => d.y1 - d.y0 + 10)
    .attr('text-anchor', 'middle')
    .style('font-weight', 'bold')
    .text(d => d.data.key);

  column
    .append('text')
    .attr('x', d => (d.x1 - d.x0) / 2)
    .attr('text-anchor', 'middle')
    .attr('y', '-0.5em')
    .attr('fill-opacity', 0.7)
    .text(d => {
      let res = d.data.values.reduce((acc, cur) => {
        return acc + cur.values[0].count;
      }, 0);
      return `${res} คน`;
    });

  const cell = node.filter(d => d.depth === 2);
  cell.selectAll('*').remove();

  cell
    .append('rect')
    .attr('fill', d => gdpGrowthColorScale(d.data.key))
    .attr('width', d => d.x1 - d.x0 - 1)
    .attr('height', d => d.y1 - d.y0 - 1);

  cell
    .filter((d, i) => i > 11)
    .append('text')
    .attr('alignment-baseline', 'middle')
    .attr('x', d => d.x1 - d.x0 + 10)
    .attr('y', d => (d.y1 - d.y0) / 2)
    .text(d => d.data.key);

  cell
    .append('text')
    .attr('x', d => (d.x1 - d.x0) / 2)
    .attr('y', d => (d.y1 - d.y0) / 2 - 7.5)
    .attr('text-anchor', 'middle')
    .attr('alignment-baseline', 'middle')
    .attr('fill', 'white')
    .text(d => `${d.value} คน`);

  cell
    .append('text')
    .attr('x', d => (d.x1 - d.x0) / 2)
    .attr('y', d => (d.y1 - d.y0) / 2 + 7.5)
    .attr('text-anchor', 'middle')
    .attr('alignment-baseline', 'middle')
    .attr('fill', 'white')
    .text(d => format(d.data.values[0].value));
}

function setUpChart() {}

async function init(loadedWaffleData) {
  data = loadedWaffleData;
  data = d3
    .nest()
    .key(d => d.work_hour)
    .key(d => d.gdp_growth)
    .entries(data);

  data = data
    .reduce((acc, { key: x, values: growth }) => {
      let res = [];
      let total = growth.reduce((acc, { key: y, values: val }) => {
        return acc + val.length;
      }, 0);
      growth.forEach(({ key: y, values: val }) => {
        res.push({ x, y, value: val.length / total, count: val.length });
      });
      return [...acc, ...res];
    }, [])
    .sort(function(a, b) {
      if (a.x < b.x) {
        return -1;
      }
      if (a.x > b.x) {
        return 1;
      }
      return 0;
    })
    .sort(function(a, b) {
      if (a.y < b.y) {
        return -1;
      }
      if (a.y > b.y) {
        return 1;
      }
      return 0;
    });

  data['columns'] = ['work_hour', 'gdp_growth', 'values'];

  data = d3
    .hierarchy(
      {
        values: d3
          .nest()
          .key(d => d.x)
          .key(d => d.y)
          .entries(data),
      },
      d => d.values
    )
    .sum(d => {
      return d.count;
    });

  window.d3 = d3;
  window.data = data;

  updateDimension();
  setUpChart();
  resize();
}

export { init as mekkoInit, resize as mekkoResize };
